import { InjectionToken } from '@angular/core';

export const RED_LAYOUT_CONFIG = new InjectionToken<any>('redLayoutConfig');
